import { TOTP } from 'otpauth'
import * as QRCode from 'qrcode'

export async function generateTOTP(email: string) {
  try {
    // Gerar um segredo aleatório usando base32
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'
    const secretLength = 20
    const secretArray = new Uint8Array(secretLength)
    crypto.getRandomValues(secretArray)
    const secret = Array.from(secretArray)
      .map(byte => chars[byte % chars.length])
      .join('')

    // Criar o objeto TOTP com o segredo gerado
    const totp = new TOTP({
      issuer: 'DeepFinance',
      label: email,
      secret: secret,
      algorithm: 'SHA1',
      digits: 6,
      period: 30
    })

    // Gerar o QR code
    const qrCodeUrl = await QRCode.toDataURL(totp.toString())

    console.log('TOTP Setup:', {
      email,
      secret,
      uri: totp.toString()
    })

    return {
      secret: secret,
      qrCodeUrl
    }
  } catch (error) {
    console.error('Error generating TOTP:', error)
    throw error
  }
}

export function verifyTOTP(secret: string, token: string): boolean {
  try {
    console.log('[TOTP] Iniciando verificação:', { 
      secretLength: secret?.length,
      token,
      time: Math.floor(Date.now() / 1000)
    })

    // Validar o segredo
    if (!secret || typeof secret !== 'string' || secret.length < 16) {
      console.error('[TOTP] Segredo inválido:', secret)
      return false
    }

    // Validar o formato do token (exatamente 6 dígitos)
    if (!/^\d{6}$/.test(token)) {
      console.error('[TOTP] Formato do token inválido:', token)
      return false
    }

    // Criar um novo objeto TOTP com as mesmas configurações do Google Authenticator
    const totp = new TOTP({
      issuer: 'DeepFinance',
      label: 'user',
      secret: secret,
      algorithm: 'SHA1', // Google Authenticator usa SHA1
      digits: 6,        // Google Authenticator usa 6 dígitos
      period: 30        // Google Authenticator usa período de 30 segundos
    })

    // Gerar o token atual
    const currentToken = totp.generate()
    
    // Verificar se o token fornecido corresponde exatamente ao token atual
    const isValid = token === currentToken

    // Logar informações de debug
    console.log('[TOTP] Resultado da validação:', {
      tokenFornecido: token,
      tokenEsperado: currentToken,
      isValid,
      timestamp: Math.floor(Date.now() / 1000)
    })

    return isValid
  } catch (error) {
    console.error('[TOTP] Erro ao validar TOTP:', error)
    return false
  }
}
